import { useState } from 'react'
import { Link } from 'react-router-dom'
import type { ActiveCampaignView } from '../../lib/active-campaigns'
import { KPI_LOADING_DISPLAY } from '../../lib/managerial-kpis'
import styles from './ActiveCampaignsPanel.module.css'

interface ActiveCampaignsPanelProps {
  campaigns: ActiveCampaignView[]
  isLoading: boolean
  isBusy?: boolean
  hasData?: boolean
}

function CampaignThumb({
  imageUrl,
  initials,
}: {
  imageUrl: string | null
  initials: string
}) {
  const [failed, setFailed] = useState(false)
  const showImage = imageUrl !== null && !failed

  if (!showImage) {
    return (
      <div className={`${styles.thumb} ${styles.thumbFallback}`} aria-hidden="true">
        {initials}
      </div>
    )
  }

  return (
    <div className={styles.thumb} aria-hidden="true">
      <img
        src={imageUrl}
        alt=""
        className={styles.thumbImage}
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
      />
    </div>
  )
}

export function ActiveCampaignsPanel({
  campaigns,
  isLoading,
  isBusy = false,
  hasData = true,
}: ActiveCampaignsPanelProps) {
  const showEmptyRecorte = hasData && campaigns.length === 0

  return (
    <section
      className={styles.card}
      aria-labelledby="active-campaigns-title"
      aria-busy={isLoading || isBusy}
    >
      <div className={styles.header}>
        <h2 id="active-campaigns-title" className={styles.title}>
          Campanhas Ativas
        </h2>
        <Link to="/campanhas" className={styles.seeAll}>
          Ver todas
        </Link>
      </div>

      {isLoading ? (
        <p className={styles.empty}>Carregando campanhas...</p>
      ) : showEmptyRecorte ? (
        <p className={styles.empty}>Nenhuma campanha ativa no recorte.</p>
      ) : campaigns.length === 0 ? (
        <p className={styles.empty}>{KPI_LOADING_DISPLAY}</p>
      ) : (
        <ul className={styles.list}>
          {campaigns.map((campaign) => (
            <li key={campaign.id} className={styles.item}>
              <CampaignThumb imageUrl={campaign.imageUrl} initials={campaign.initials} />

              <div className={styles.campaign}>
                <p className={styles.campaignTitle}>{campaign.title}</p>
                <p className={styles.campaignMeta}>{campaign.prizeLabel}</p>
                <p className={styles.campaignMeta}>{campaign.drawLabel}</p>
              </div>

              <span className={`${styles.status} ${styles.statusActive}`}>
                {campaign.statusLabel}
              </span>

              <dl className={styles.metrics}>
                <div className={styles.metric}>
                  <dt>Números</dt>
                  <dd>{campaign.formattedNumbers}</dd>
                </div>
                <div className={styles.metric}>
                  <dt>GMV</dt>
                  <dd>{campaign.formattedRevenue}</dd>
                </div>
              </dl>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
